export default {
    BUYFLOW: {
        INFO: {
            AUTOPAY_AVAILABLE: {
                heading: 'AutoPay and EcoSave is available in your location.',
                subheading: 'You will see a savings of $10 per month.',
            },
        },
        SUCCESS: {
            ADDRESS_UPDATED: {
                heading: 'Your address has been updated.',
                subheading: 'You will now be redirected somewhere.',
            },
        },
        WARNINGS: {
            UPGRADED_TV_PACKAGE_REQUIRED: {
                heading: 'Upgraded TV package is required.',
                subheading: 'Please upgrade TV package first before proceeding.',
            },
            UNAVAILABLE_DATE: {
                heading: 'The selected time is no longer available.',
                subheading: 'Please select a new time. If problem persists, please call 844-432-3610 to complete your order.',
            },
        },
        ERRORS: {
            OFFLINE: {
                heading: 'Service unavailable',
                subheading: 'Please call 855-284-3806 for phone support.',
            },
            RETRIEVE_DATES: {
                heading: 'Unable to get schedule dates',
                subheading: 'Please call 844-432-3610 to complete your order.',
            },
        },
    },
    COMMON: {
        ERRORS: {
            SERVER: {
                heading: 'Service is unavailable',
                subheading: `Please call our customer service team at
                (888)536-9600 for assistance.
                `
            },
            NOT_FOUND: {
                heading: 'Account not found',
                subheading: `We could not find an account matching the information provided.
                Please verify the information and try again. If you need further assistance, please
                call 888-536-9600 for assistance.`,
            },
            UNAUTHORIZED: {
                heading: 'Unauthorized',
                subheading: `If you need further assistance, please
                call 888-536-9600 for assistance.`,
            },
            FORBIDDEN: {
                heading: 'Your request can not be processed',
                subheading: `You are not authorized to perform such action. If you need further assistance, please
                call 888-536-9600 for assistance.`,
            },
            UNEXPECTED: {
                heading: 'Oops something went wrong!',
                subheading: `Please try again later. If you need further assistance, please
                call 888-536-9600 for assistance.`,
            },
            REFERRAL_CODE: {
                heading: 'Invalid referral code',
                subheading: 'Please verify the referral code and try again.',
            }
        },
    },
    EQUIPMENT_SWAP: {
        ERRORS: {
            SERVER: {
                heading: `Server error`,
                subheading: `We are experiencing technical difficulties. Please contact our customer care team for assistance at 844.574.8435.`
            },
            REQUEST_EXCEEDED: {
                heading: `Maximum number of swap requests reached`,
                subheading: `Oops! It looks like you reached your online ordering limit for your new equipment. Please contact our customer care team for assistance at 844.574.8435.`
            },
            USER_NOT_FOUND: {
                heading: `Account not found`,
                subheading: `Oops! Your account cannot be found or is not eligible for this upgrade. Please contact our customer care team for assistance at 844.574.8435.`
            },

        },
    },
}
